export class Button {
	public text:string;
	public color:string;

	constructor(text:string, color:string) {
		this.text = text;
		this.color = color;
	}
}